module.exports = __webpack_public_path__ + "static/media/PuppyBellies.cd131e78.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/PuppyBellies.ttf
// module id = 120
// module chunks = 0